export default {"src":"/_next/static/media/0x76fb31fb4af56892a25e32cfc43de717950c9278.94d275b4.svg","height":126,"width":126,"blurWidth":0,"blurHeight":0};